import Api from '@/services/Api'

export default {
  /**
   * Fire Login Request.
   * @param {Object} payload {user: "", password: ""}
   */
  login (payload) {
    return Api().post('auth/login', payload)
  },

  logout() {
    localStorage.removeItem('token');
    return Api().post("auth/logout")
  },

  getUser() {
    return Api().get('user')
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },

  // User Management Methods
  getAllUsers() {
    return Api().get('usermanagement/users');
  },

  getUserById(id) {
    return Api().get(`usermanagement/users/${id}`);
  },

  createUser(userData) {
    return Api().post('usermanagement/users', userData);
  },

  updateUser(id, userData) {
    return Api().put(`usermanagement/users/${id}`, userData);
  },

  deleteUser(id) {
    return Api().delete(`usermanagement/users/${id}`);
  },

  // Key Management Methods
  getUserByKey(key) {
    return Api().get(`usermanagement/users/key/${key}`);
  },

  assignKeyToUser(userId, key) {
    return Api().put(`usermanagement/users/${userId}/assign-key`, { key });
  }
}